var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6715 26.6654L51.5691 26.7678H34.2297V23.8608C34.2297 22.2553 35.5312 20.9538 37.1367 20.9538H40.0436C40.0436 19.3484 41.3451 18.0469 42.9506 18.0469C44.5561 18.0469 45.8575 19.3484 45.8575 20.9538H48.7645C50.37 20.9538 51.6715 22.2553 51.6715 23.8608V26.6654ZM60.3924 34.5974V61.6514C60.3924 63.2568 59.0909 64.5583 57.4854 64.5583H28.4158C26.8103 64.5583 25.5088 63.2568 25.5088 61.6514V26.7678C25.5088 25.1623 26.8103 23.8608 28.4158 23.8608H31.3227V26.7678H28.4158V58.7444H57.4854V37.5044L60.3924 34.5974Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5713 50.4466L38.5713 41.4466L56.4916 23.5156L62.4916 29.5156L44.5713 47.4466L35.5713 50.4466ZM42.9507 44.8245L58.249 29.5156L56.4916 27.7583L41.1934 43.0671L40.3147 45.7032L42.9507 44.8245Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardEdit);
export default __webpack_public_path__ + "static/media/clipboard-edit.13cd6864.svg";
export { ForwardRef as ReactComponent };